var viewer_rtlignore_default = {
  "gallery_container": "_6VwX9",
  "imageTitleContainer": "bT8LV",
  "clickableItem": "SwbGU",
  "prerender": "dRDB8",
  "expandButton": "V0eCG",
  "itemContainer": "W-YW3",
  "expandIcon": "Bj35L",
  "itemOverlay": "AO3aI",
  "imageTitle": "yE-T2",
  "pointer": "uni4g",
  "fadeIn": "_4va2y",
  "changing_background": "PFJkK"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
